module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Blue-Monster-Angry-Web-640.76e05936.jpg";